<div #canvas id="canvas" [class.side-panel-collapsed]="sidePanelCollapsed">

    <!-- <button (click)="fitToScreen()" (touchend)="fitToScreen()">Fit</button> -->

    <div id="canvas-inner" [style]="{transform: 'scale(' + zoom + ')', '-ms-transform': 'scale(' + zoom + ')', '-webkit-transform': 'scale(' + zoom + ')'}">

        <!-- no section message -->
        @if (workingDateSections != null && workingDateSections.length <= 0) {
            <span class="no-section-message">{{ 'tablesPlan.canvas.noSection' | translate }}</span>
            <span [canWrite]="'EditTablesPlanPocket'" class="go-to-add-sections-message">
                <span >{{ 'tablesPlan.canvas.goToAddSection1' | translate }}</span>
                <a class="btn btn-sm btn-main ms-2 me-2 px-2" (click)="setTablesPlanMode(true)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"
                        stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                    </svg>
                </a>
                <span>{{ 'tablesPlan.canvas.goToAddSection2' | translate }}</span>
            </span>
        }

        <!-- tables -->
        @for (table of sectionTables; track table.tableId) {
            <app-table #tables [table]="table" [selected]="tableIsSelected(table)" (onClick)="tableClick($event)" (onDragStart)="dragStarted($event)"
                (onDragMove)="dragMoved($event)" (onDragEnd)="dragEnded($event)" [reservations]="reservationsFilteredByShift"></app-table>
        }

        @if (editingTable != null && editingTable.isNew) {
            <app-table #tables [table]="editingTable.table" [selected]="tableIsSelected(editingTable.table)" (onClick)="tableClick($event)" (onDragStart)="dragStarted($event)"
                (onDragMove)="dragMoved($event)" (onDragEnd)="dragEnded($event)" [reservations]="reservationsFilteredByShift"></app-table>
        }

        <!-- lines -->
        @if (showTablesConnection && !editMode) {
            @for (line of tablesConnections; track $index) {
                <app-line [line]="line"></app-line>
            }
        }

    </div>

    <!-- zoom slider -->
    <div id="slide-container">
        <a class="btn btn-sm me-2 px-2" role="button" (click)="fitToScreen()">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24"
                stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M7.5 3.75H6A2.25 2.25 0 0 0 3.75 6v1.5M16.5 3.75H18A2.25 2.25 0 0 1 20.25 6v1.5m0 9V18A2.25 2.25 0 0 1 18 20.25h-1.5m-9 0H6A2.25 2.25 0 0 1 3.75 18v-1.5M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
            </svg>
        </a>
        <input #slider id="slider" type="range" min="0.1" max="4" step="0.1" [ngModel]="zoom"
            (input)="zoomSliderChange($event)">
    </div>

    <!-- drag helper lines -->
    @if (dragging) {
        @for (line of dragTableHelpers; track $index) {
            <div class="drag-helper" [style]="{top: line.top + 'px', left: line.left + 'px'}"
                [class.vertical]="line.isVertical"></div>
        }
    }

</div>

<div #toast class="toast position-fixed bottom-0 start-50 translate-middle-x text-bg-danger z-2" role="alert" aria-live="assertive" aria-atomic="true"
    data-bs-config='{"delay":2500, "autohide": true, "animation": true}'>
    <div class="toast-body text-center">
      <p>{{validationMessage}}</p>
    </div>
</div>